import React from 'react';
import styles from './styles/Luna.module.css';
import StaticText from './StaticText';

const Luna = ({lunaDialogs}) =>
    <div className={styles.lunaContainer}>
        <div className={styles.lunaImageContainer}>
            <img src={'https://assets.nearshored.ai/luna.svg'} alt="Luna" />
            <div className={styles.ellipseShadow} />
        </div>

        <div className={styles.lunaDialog}>
            <StaticText texts={lunaDialogs} />
        </div>
    </div>



const ErrorLuna = ({lunaDialogs}) => <div className={styles.lunaContainer}>
    <div className={styles.lunaImageContainer}>
        <img src={'https://assets.nearshored.ai/errorLuna.svg'} alt="Luna" />
        <div className={styles.ellipseShadow} />
    </div>

    <div className={`${styles.lunaDialog} ${styles.errorLunaDialog}`}>
        <StaticText texts={lunaDialogs} />
    </div>
</div>

export { Luna, ErrorLuna };